import type { Language } from '../../i18n';
import { useTranslation } from '../../hooks/useTranslation';

interface CompleteStepProps {
  exchange: string;
  language: Language;
  onBackToList: () => void;
}

const CompleteStep = ({ exchange, onBackToList }: CompleteStepProps) => {
  const { t } = useTranslation();
  const exchangeName = exchange.toUpperCase();

  const nextSteps = [
    {
      number: 1,
      text: t('settings.emailVerification')
    },
    {
      number: 2,
      text: t('settings.verificationSent')
    },
    {
      number: 3,
      text: `${exchangeName} - ${t('rebate.autoRebate')}`
    }
  ];

  return (
    <div className="flex flex-col items-center">
      {/* Large Checkmark */}
      <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center mb-6 relative">
        <div className="absolute inset-0 bg-primary rounded-full opacity-30 animate-ping" />
        <svg 
          className="w-12 h-12 text-black relative z-10" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      </div>

      {/* Success Title */}
      <h2 className="text-2xl font-bold text-white mb-3">
        {t('rebate.completed')}
      </h2>

      {/* Success Message */}
      <p className="text-base text-tg-hint text-center mb-8 px-4">
        {`${exchangeName} - ${t('common.success')}`}
      </p>

      {/* Next Steps Card */}
      <div className="w-full bg-tg-secondary rounded-xl p-6 mb-6">
        <h3 className="text-lg font-bold text-white mb-4">
          {t('common.next')}
        </h3>
        <div className="space-y-4">
          {nextSteps.map((step) => (
            <div key={step.number} className="flex items-start gap-3">
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-black font-bold text-sm">{step.number}</span>
              </div>
              <p className="text-sm text-white flex-1 pt-1">{step.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Back to List Button */}
      <button
        onClick={onBackToList}
        className="w-full py-3 bg-tg-secondary text-white rounded-xl text-base font-semibold flex items-center justify-center gap-2 transition-opacity active:opacity-80"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        {t('common.back')}
      </button>
    </div>
  );
};

export default CompleteStep;

